import React, { useState, useRef } from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HeroSection from './components/sections/HeroSection';
import ServicesSection from './components/sections/ServicesSection';
import ProcessSection from './components/sections/ProcessSection';
import TestimonialsSection from './components/sections/TestimonialsSection';
import AboutSection from './components/sections/AboutSection';
import ContactSection from './components/sections/ContactSection';
import IndustriesSection from './components/sections/IndustriesSection';
import SREDCalculator from './components/sections/SREDCalculator';
import SREDBasicsSection from './components/sections/SREDBasicsSection';
import FAQSection from './components/sections/FAQSection';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('industries');
  const topRef = useRef(null);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Handle tab change - always scroll to top when switching tabs
  const handleTabChange = (tab) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  };

  return (
    <div className="App min-h-screen bg-black" ref={topRef}>
      <Header 
        activeTab={activeTab} 
        setActiveTab={handleTabChange} 
        scrollToTop={scrollToTop}
      />
      
      {activeTab === 'industries' ? (
        // Philcan Industries - Consulting & Process Improvement
        <>
          <HeroSection type="industries" />
          <ServicesSection type="industries" />
          <ProcessSection type="industries" />
          <TestimonialsSection />
          <AboutSection />
          <ContactSection type="industries" />
        </>
      ) : (
        // Philcan Innovation - SR&ED & Innovation Funding
        <>
          <HeroSection type="innovation" />
          <SREDBasicsSection />
          <SREDCalculator />
          <ProcessSection type="innovation" />
          <IndustriesSection />
          <FAQSection />
          <ContactSection type="innovation" />
        </>
      )}
      
      <Footer scrollToTop={scrollToTop} />
    </div>
  );
}

export default App;
